import * as React from 'react'

import type { SVGProps } from 'react'

const SvgGelIconChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M10.4 14.3 26.5 31h-6.4L5.5 16 20.1 1h6.4L10.4 17.7v-3.4z" stroke="none" />
  </svg>
)

export default SvgGelIconChevronLeft
